"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _ArrowBackRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackRounded"));
var _Table = _interopRequireDefault(require("@mui/material/Table/Table"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow/TableRow"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell/TableCell"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody/TableBody"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _PricingDesignForm = _interopRequireDefault(require("./PricingDesignForm"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _Bubble = _interopRequireDefault(require("../../components/Bubble"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _system = require("@mui/system");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledTableRow = (0, _system.styled)(_TableRow["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.primary.main
  };
});
var Revisions = /*#__PURE__*/function (_PureComponent) {
  function Revisions() {
    var _this;
    (0, _classCallCheck2["default"])(this, Revisions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Revisions, [].concat(args)), _this.state = {
      revisions: [],
      selectedRevision: null
    }, _this._selectRevision = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(revisionID) {
        var selectedRevision;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getSinglePricingRevision(revisionID);
            case 2:
              selectedRevision = _context.sent;
              _this.setState({
                selectedRevision: selectedRevision
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this._handleGoBack = function () {
      if (_this.state.selectedRevision) {
        _this.setState({
          selectedRevision: null
        });
        return null;
      }
      return _this.props.goBack();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(Revisions, _PureComponent);
  return (0, _createClass2["default"])(Revisions, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var revisions;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.props.getPricingRevisions(this.props.selectedDesignID);
            case 2:
              revisions = _context2.sent;
              this.setState({
                revisions: revisions
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectedClassID = _this$props.selectedClassID,
        selectedDesignID = _this$props.selectedDesignID,
        accountID = _this$props.accountID,
        commissions = _this$props.commissions,
        designs = _this$props.designs;
      var styles = {
        container: Theme.globalStyles.containerControlSite,
        content: Theme.globalStyles.content,
        contentBlock: Theme.globalStyles.contentBlock,
        tabRoot: Theme.globalStyles.tabRoot,
        tabSelected: Theme.globalStyles.tabSelected,
        tabsIndicator: Theme.globalStyles.tabsIndicator,
        saveBtn: {
          display: 'block',
          marginLeft: 'auto',
          marginTop: "20px !important"
        },
        header: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: "space-between"
        },
        headerTitleBlock: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        },
        // newButton: {
        //     padding: 0,
        //     fontSize: 12,
        //     color: theme.palette.primary.main
        // },
        // plusIcon: {
        //     color: theme.palette.primary.main,
        //     fontSize: 16,
        //     padding: 0
        // },
        backBtn: {
          minWidth: "30px",
          padding: "2px",
          marginRight: "5px",
          marginLeft: "-5px"
        },
        table: _objectSpread(_objectSpread({}, Theme.globalStyles.table), {}, {
          border: "2px solid #F1F1F1",
          backgroundColor: '#FFF'
        }),
        scrollbar: Theme.globalStyles.scrollbar,
        tableHeading: {
          paddingTop: "10px",
          paddingBottom: "10px",
          paddingRight: "2vw",
          paddingLeft: "2vw",
          fontFamily: Theme.fonts.type.heading,
          color: Theme.colors.surface,
          whiteSpace: "nowrap",
          border: "none"
        },
        tableCell: {
          paddingTop: "10px",
          paddingBottom: "10px",
          fontFamily: Theme.fonts.type.light,
          whiteSpace: "nowrap",
          paddingRight: "2vw",
          paddingLeft: "2vw",
          color: Theme.colors.mainTextGrey
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerTitleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: styles.backBtn,
        onClick: this._handleGoBack,
        transparent: true
      }, /*#__PURE__*/_react["default"].createElement(_ArrowBackRounded["default"], null)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0"
      }, "Revisions")), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: designs[selectedClassID][selectedDesignID].title,
        isSelected: true,
        clickable: false
      })), this.state.selectedRevision ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: "Revision Review (".concat(this.state.selectedRevision.id, ")"),
        subtitle: "You have loaded a past revision for the selected pricing. Changes made by: ".concat(this.state.selectedRevision.changedBy.name, " on ").concat(dates.getLocalDisplay(this.state.selectedRevision.timestamp, 'lll'), ". Pricing changes are disabled while in the revision view.")
      }), /*#__PURE__*/_react["default"].createElement(_PricingDesignForm["default"], {
        classID: selectedClassID,
        designID: selectedDesignID,
        designs: designs,
        accountID: accountID,
        commissions: commissions,
        pricing: this.state.selectedRevision,
        revision: true
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.state.revisions || this.state.revisions.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, "You haven't saved any changes to the current plan design. All plan design revisions will show up here where you can view and revert to past versions.") : /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          overflow: "auto",
          maxHeight: 600
        }, styles.scrollbar)
      }, /*#__PURE__*/_react["default"].createElement(_Table["default"], null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        style: styles.tableHeading
      }, "Revision ID"), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        style: styles.tableHeading
      }, "Design"), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        style: styles.tableHeading
      }, "Change By"), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        style: styles.tableHeading
      }, "Date of Change"), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
        style: styles.tableHeading
      }))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, this.state.revisions.map(function (revision, index) {
        var backgroundObject = {
          border: "none"
        };
        if (index % 2 !== 0) {
          backgroundObject = {
            backgroundColor: Theme.colors.backgroundGrey,
            border: "none"
          };
        }
        return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
          key: revision.revisionID
        }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
          style: _objectSpread(_objectSpread({}, styles.tableCell), backgroundObject)
        }, revision.revisionID), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
          style: _objectSpread(_objectSpread({}, styles.tableCell), backgroundObject)
        }, revision.title), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
          style: _objectSpread(_objectSpread({}, styles.tableCell), backgroundObject)
        }, "".concat(revision.changedByName, " (").concat(revision.changedByType, ")")), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
          style: _objectSpread(_objectSpread({}, styles.tableCell), backgroundObject)
        }, dates.getLocalDisplay(revision.effectiveDate, 'lll')), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], {
          style: _objectSpread(_objectSpread({}, styles.tableCell), backgroundObject)
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          transparent: true,
          onClick: function onClick() {
            _this2._selectRevision(revision.revisionID);
          }
        }, "View")));
      }))))));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = Revisions;